import Vue from 'vue'
import Router from 'vue-router'
// Landing
import Landing from '../components/Landing.vue'
// Login
import Login from '../components/Login.vue'
// Join
import Join from '../components/join/Join.vue'
import JoinForm from '../components/join/JoinForm.vue'
// Main
import Main from '../components/Main.vue'
// Dashboard
import Dashboard from '../components/dashboard/Dashboard.vue'
// Modem Info
import Modem from '../components/modemInfo/Modem.vue'
import ModemList from '../components/modemInfo/ModemList.vue'
import ModemForm from '../components/modemInfo/ModemForm.vue'
// Modem AS
import ModemAS from '../components/modemAS/ModemAS.vue'
import ModemASRequestList from '../components/modemAS/ModemASRequestList.vue'
import ModemASAcceptedList from '../components/modemAS/ModemASAcceptedList.vue'
import ModemASProgressList from '../components/modemAS/ModemASProgressList.vue'
import ModemASCompleteList from '../components/modemAS/ModemASCompleteList.vue'
// Shadow Quality
import ShadowQuality from '../components/shadowQuality/ShadowQuality.vue'
import ShadowQualityRequestList from '../components/shadowQuality/ShadowQualityRequestList.vue'
import ShadowQualityPendingList from '../components/shadowQuality/ShadowQualityPendingList.vue'
import ShadowQualityAcceptedList from '../components/shadowQuality/ShadowQualityAcceptedList.vue'
import ShadowQualityProgressList from '../components/shadowQuality/ShadowQualityProgressList.vue'
import ShadowQualityCompleteList from '../components/shadowQuality/ShadowQualityCompleteList.vue'
// Line Shut Down
import LineShutDown from '../components/lineShutDown/LineShutDown.vue'
import LineShutDownRequestList from '../components/lineShutDown/LineShutDownRequestList.vue'
import LineShutDownProgressList from '../components/lineShutDown/LineShutDownProgressList.vue'
import LineShutDownCompleteList from '../components/lineShutDown/LineShutDownCompleteList.vue'
// Line Startup
import LineStartup from '../components/lineStartup/LineStartup.vue'
import LineStartupRequestList from '../components/lineStartup/LineStartupRequestList.vue'
import LineStartupProgressList from '../components/lineStartup/LineStartupProgressList.vue'
import LineStartupCompleteList from '../components/lineStartup/LineStartupCompleteList.vue'
// Charge
import Charge from '../components/charge/Charge.vue'
import ChargeList from '../components/charge/ChargeList.vue'
import ChargeForm from '../components/charge/ChargeForm.vue'
// Member
import Member from '../components/member/Member.vue'
import MemberList from '../components/member/MemberList.vue'
import MemberForm from '../components/member/MemberForm.vue'
// My Info
import MyInfoForm from '../components/profile/MyInfoForm.vue'
// Manual
import Manual from '../components/manual/Manual.vue'
import ManualModemASRequest from '../components/manual/ManualModemASRequest.vue'
import ManualModemASAccepted from '../components/manual/ManualModemASAccepted.vue'
import ManualModemASProgress from '../components/manual/ManualModemASProgress.vue'
import ManualModemASComplete from '../components/manual/ManualModemASComplete.vue'
import ManualShadowQualityRequest from '../components/manual/ManualShadowQualityRequest.vue'
import ManualShadowQualityPending from '../components/manual/ManualShadowQualityPending.vue'
import ManualShadowQualityAccepted from '../components/manual/ManualShadowQualityAccepted.vue'
import ManualShadowQualityProgress from '../components/manual/ManualShadowQualityProgress.vue'
import ManualShadowQualityComplete from '../components/manual/ManualShadowQualityComplete.vue'
import ManualLineShutDownRequest from '../components/manual/ManualLineShutDownRequest.vue'
import ManualLineShutDownProgress from '../components/manual/ManualLineShutDownProgress.vue'
import ManualLineShutDownComplete from '../components/manual/ManualLineShutDownComplete.vue'
import ManualLineStartupRequest from '../components/manual/ManualLineStartupRequest.vue'
import ManualLineStartupProgress from '../components/manual/ManualLineStartupProgress.vue'
import ManualLineStartupComplete from '../components/manual/ManualLineStartupComplete.vue'
// Mobile
import Mobile from '../components/Mobile.vue'
import ModemSearch from '../components/mobile/ModemSearch.vue'
import ModemView from '../components/mobile/ModemView.vue'
// Notice
import Notice from '../components/notice/Notice.vue'
import NoticeList from '../components/notice/NoticeList.vue'
import NoticeForm from '../components/notice/NoticeForm.vue'

Vue.use(Router)

const requireAuth = () => (to, from, next) => {
  if (sessionStorage.getItem('accessToken') != null &&
    sessionStorage.getItem('accessToken') !== 'null' &&
    sessionStorage.getItem('accessToken') !== '' &&
    sessionStorage.getItem('accessToken').length > 0) {
    next()
  } else {
    next('/Login')
  }
}

export default new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  routes: [
    {
      path: '',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Join',
      name: 'Join',
      component: Join,
      children: [
        {
          path: 'Form',
          name: 'JoinForm',
          component: JoinForm
        }
      ]
    },
    {
      path: '/Manual',
      name: 'Manual',
      component: Manual,
      children: [
        {
          path: 'ModemASRequest',
          name: 'ManualModemASRequest',
          component: ManualModemASRequest
        },
        {
          path: 'ModemASAccepted',
          name: 'ManualModemASAccepted',
          component: ManualModemASAccepted
        },
        {
          path: 'ModemASProgress',
          name: 'ManualModemASProgress',
          component: ManualModemASProgress
        },
        {
          path: 'ModemASComplete',
          name: 'ManualModemASComplete',
          component: ManualModemASComplete
        },
        {
          path: 'ShadowQualityRequest',
          name: 'ManualShadowQualityRequest',
          component: ManualShadowQualityRequest
        },
        {
          path: 'ShadowQualityPending',
          name: 'ManualShadowQualityPending',
          component: ManualShadowQualityPending
        },
        {
          path: 'ShadowQualityAccepted',
          name: 'ManualShadowQualityAccepted',
          component: ManualShadowQualityAccepted
        },
        {
          path: 'ShadowQualityProgress',
          name: 'ManualShadowQualityProgress',
          component: ManualShadowQualityProgress
        },
        {
          path: 'ShadowQualityComplete',
          name: 'ManualShadowQualityComplete',
          component: ManualShadowQualityComplete
        },
        {
          path: 'LineShutDownRequest',
          name: 'ManualLineShutDownRequest',
          component: ManualLineShutDownRequest
        },
        {
          path: 'LineShutDownProgress',
          name: 'ManualLineShutDownProgress',
          component: ManualLineShutDownProgress
        },
        {
          path: 'LineShutDownComplete',
          name: 'ManualLineShutDownComplete',
          component: ManualLineShutDownComplete
        },
        {
          path: 'LineStartupRequest',
          name: 'ManualLineStartupRequest',
          component: ManualLineStartupRequest
        },
        {
          path: 'LineStartupProgress',
          name: 'ManualLineStartupProgress',
          component: ManualLineStartupProgress
        },
        {
          path: 'LineStartupComplete',
          name: 'ManualLineStartupComplete',
          component: ManualLineStartupComplete
        }
      ]
    },
    {
      path: '',
      name: 'Main',
      component: Main,
      beforeEnter: requireAuth(),
      children: [
        {
          path: 'Dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'Modem',
          name: 'Modem',
          component: Modem,
          children: [
            {
              path: 'List',
              name: 'ModemList',
              component: ModemList
            },
            {
              path: 'Form',
              name: 'ModemForm',
              component: ModemForm
            }
          ]
        },
        {
          path: 'ModemAS',
          name: 'ModemAS',
          component: ModemAS,
          children: [
            {
              path: 'RequestList',
              name: 'ModemASRequestList',
              component: ModemASRequestList
            },
            {
              path: 'AcceptedList',
              name: 'ModemASAcceptedList',
              component: ModemASAcceptedList
            },
            {
              path: 'ProgressList',
              name: 'ModemASProgressList',
              component: ModemASProgressList
            },
            {
              path: 'CompleteList',
              name: 'ModemASCompleteList',
              component: ModemASCompleteList
            }
          ]
        },
        {
          path: 'ShadowQuality',
          name: 'ShadowQuality',
          component: ShadowQuality,
          children: [
            {
              path: 'RequestList',
              name: 'ShadowQualityRequestList',
              component: ShadowQualityRequestList
            },
            {
              path: 'PendingList',
              name: 'ShadowQualityPendingList',
              component: ShadowQualityPendingList
            },
            {
              path: 'AcceptedList',
              name: 'ShadowQualityAcceptedList',
              component: ShadowQualityAcceptedList
            },
            {
              path: 'ProgressList',
              name: 'ShadowQualityProgressList',
              component: ShadowQualityProgressList
            },
            {
              path: 'CompleteList',
              name: 'ShadowQualityCompleteList',
              component: ShadowQualityCompleteList
            }
          ]
        },
        {
          path: 'LineShutDown',
          name: 'LineShutDown',
          component: LineShutDown,
          children: [
            {
              path: 'RequestList',
              name: 'LineShutDownRequestList',
              component: LineShutDownRequestList
            },
            {
              path: 'ProgressList',
              name: 'LineShutDownProgressList',
              component: LineShutDownProgressList
            },
            {
              path: 'CompleteList',
              name: 'LineShutDownCompleteList',
              component: LineShutDownCompleteList
            }
          ]
        },
        {
          path: 'LineStartup',
          name: 'LineStartup',
          component: LineStartup,
          children: [
            {
              path: 'RequestList',
              name: 'LineStartupRequestList',
              component: LineStartupRequestList
            },
            {
              path: 'ProgressList',
              name: 'LineStartupProgressList',
              component: LineStartupProgressList
            },
            {
              path: 'CompleteList',
              name: 'LineStartupCompleteList',
              component: LineStartupCompleteList
            }
          ]
        },
        {
          path: 'Charge',
          name: 'Charge',
          component: Charge,
          children: [
            {
              path: 'List',
              name: 'ChargeList',
              component: ChargeList
            },
            {
              path: 'Form',
              name: 'ChargeForm',
              component: ChargeForm
            }
          ]
        },
        {
          path: 'Member',
          name: 'Member',
          component: Member,
          children: [
            {
              path: 'List',
              name: 'MemberList',
              component: MemberList
            },
            {
              path: 'Form',
              name: 'MemberForm',
              component: MemberForm
            }
          ]
        },
        {
          path: 'Notice',
          name: 'Notice',
          component: Notice,
          children: [
            {
              path: '',
              redirect: { name: 'NoticeList' }
            },
            {
              path: 'List',
              name: 'NoticeList',
              component: NoticeList
            },
            {
              path: 'Form',
              name: 'NoticeForm',
              component: NoticeForm
            }
          ]
        },
        {
          path: 'MyInfo',
          name: 'MyInfo',
          component: MyInfoForm
        }
      ]
    },
    {
      path: '',
      name: 'Mobile',
      component: Mobile,
      beforeEnter: requireAuth(),
      children: [
        {
          path: 'ModemSearch',
          name: 'ModemSearch',
          component: ModemSearch
        },
        {
          path: 'ModemView',
          name: 'ModemView',
          component: ModemView
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js